<template>
  <div>
    <QuillEditor ref="quill-editor" v-model:content="content" :options="editorOption" @update:content="setValue" contentType="html" style="margin-bottom: 10px" />
    <!-- 使用自定义图片上传 -->
    <input type="file" hidden accept=".jpg,.png" ref="fileBtn" @change="handleUpload" />
  </div>
</template>

<script>
import {QuillEditor, Quill } from '@vueup/vue-quill'
import { ImageDrop } from 'quill-image-drop-module';
import imageResize from 'quill-image-resize-module';
Quill.register('modules/ImageDrop', ImageDrop);
Quill.register('modules/imageResize', imageResize);
import { uploadImg } from '@/api/system/notice'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

const Size = Quill.import('attributors/style/size')
Size.whitelist = ['12px', '14px', '16px', '18px', '20px', '32px', '34px']
Quill.register(Size, true)

// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用
  [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: '-1' }, { indent: '+1' }], // 缩进
  [{ direction: 'rtl' }], // 文本方向
  [{ size: Size.whitelist }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ align: [] }], // 对齐方式
  ['clean'], // 清除文本格式
  ['link', 'image', 'video'] // 链接、图片、视频
]
export default {
  name: 'EditDictDialog',
  components: { QuillEditor },
  props: {
    value: {
      type: String,
      default: ''
    },
    /* 类型（base64格式、url格式） */
    type: {
      type: String,
      default: "url",
    }
  },
  data() {
    return {
      content: '',
      editorOption: {
        theme: 'snow',
        placeholder: '请输入内容',
        blotFormatter: {
          toolbar: {
            mainClassName: 'blot-formatter__toolbar'
          }
        },
        modules: {
          toolbar: {
            container: toolbarOptions,
          },
          imageResize: {
						displayStyles: {
							backgroundColor: 'black',
							border: 'none',
							color: 'white'
						},
						modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
					}
        }
      }
    }
  },
  methods: {
    setValue(value) {
      this.$emit('updateValue', value)
    },
    handleUpload(e) {
      const files = Array.prototype.slice.call(e.target.files)
      if (!files) {
        return
      }
      const blob = new Blob([files[0]], { type: files[0].type });
      let formData = new FormData();
      formData.append("file", blob);
      uploadImg(formData).then(res => {
        const length = this.Quill.getSelection().index
        this.Quill.insertEmbed(length, 'image', res.data)
        this.Quill.setSelection(length + 1)
      })
    },
    imgHandler(state) {
      if(state) {
        this.$refs.fileBtn.click()
      }
    }
  },
  mounted() {
    this.content = this.value
    this.Quill = this.$refs['quill-editor'].getQuill();
    if (this.type == 'url') {
      let toolbar = this.Quill.getModule("toolbar");
      toolbar.addHandler("image", (value) => {
        this.uploadType = "image";
        if (value) {
          this.$refs.fileBtn.click()
        } else {
          this.Quill.format("image", false);
        }
      });
    }
  }
}
</script>
<style>
 .el-form-item__content {
  display: inline
}
 .el-dialog__footer{
  margin-top: 10px;
}
 .ql-container {
  height: 300px;
  line-height: normal;
  width: auto;
}

 span.ql-size {
  max-width: 80px !important;
}

 .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}

 .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

 .ql-tooltip[data-mode="video"] {
  left: 0 !important;
}

 .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

 .ql-picker.ql-size .ql-picker-label::before,
.ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: "12px";
}

.ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14px";
}

.ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16px";
}

.ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px";
}

.ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20px";
}

 .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32px";
}

 .ql-picker.ql-size .ql-picker-label[data-value="34px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="34px"]::before {
  content: "34px";
}

:deep .ql-picker.ql-header .ql-picker-label::before,
.ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}

 .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}

 .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}

 .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}

 .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}

 .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}

 .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

 .ql-picker.ql-font .ql-picker-label::before,
.ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}

 .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}

 .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>

